//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        version_desc: '',
      },
      formRules: {
        version_desc: [
          { required: true, message: '变更表述不可为空', trigger: 'blur' },
          { min: 0, max: 200, message: '变更描述不能超过100个字符', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.formData.version_desc = '';
        this.$refs?.ruleForm?.clearValidate();
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('close', '');
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$emit('close', this.formData.version_desc);
      });
    },
  },
};
